export const isPrimitive = (value) => value !== Object(value);
